import { useQuery } from '@tanstack/react-query';
import { getIssuesCaughtVsResolved } from '../services/AnalyticReportsService';
export default function useIssuesCaughtVsResolved(filters) {
    return useQuery(['issuesCaughtVsResolved', filters.values.dateRange], () => getIssuesCaughtVsResolved(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
